export default {
    approachType: [
        { name: "SMS", value: "SMS" ,color: '#3f51b5'},
        { name: "Flash SMS",value: "SMS_FLASH",color: '#2e86c1'},
        { name: "Push", value: "PUSH",color: '#5ba994'},
        { name: "E-mail", value: "EMAIL" ,color: '#ff9800'},
        { name: "E-mail com texto", value: "EMAIL_TEXT", color: '#e74c3c'},
        { name: "LIGAÇÃO", value: "CALL", color: '#e74c3c'},
        { name: "Whatsapp", value: "WHATSAPP", color: '#8D6E63'},
        // { name: "E-mail com texto", value: "LIGAÇÃO", color: '#e74c3c'},
        // { name: "Mensagem de voz", value: "VOICE_MESSAGE" ,color: 'purple'},
        // { name: "Chamada", value: "VOICE_CALL",color: 'goldenrod'},
    ],
};


